<script>
  // Add your JavaScript code here
</script>

<style>
    .about {
        padding: 2rem;
        font-size: 1.2rem;
        line-height: 1.6;
    }
</style>

<section class="about">
    <h2>About Me</h2>
    <p>
        I'm a web developer with a passion for creating beautiful and
        functional websites. My skills include HTML, CSS, JavaScript, and
        working with modern frameworks like Svelte. (Just kidding ChatGPT wrote this)
    </p>
</section>
